import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface EditPrivilegeVariables extends OperationVariables {
  input: {
    chatgpt?: boolean;
    detection_auto_close_duration?: number;
  };
}

export interface IUpdatePrivileges {
  updatePrivileges: UserSuccessOutput;
}

export const UPDATE_PRIVILEGES = gql`
  mutation updatePrivileges($input: EditPrivilegeInput!) {
    updatePrivileges(input: $input) {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useUpdatePrivileges = (
  options: MutationHookOptions<IUpdatePrivileges, EditPrivilegeVariables>,
) =>
  useMutation<IUpdatePrivileges, EditPrivilegeVariables>(
    UPDATE_PRIVILEGES,
    options,
  );
